import axios from 'axios';
import { Language, LoginDTO, AuthResponse, ResetPasswordDTO } from '../model/Types';
import { authConfig } from '../store/UserStore';
import { BALANCE_PATH_BASE_URL } from './AdminApi';
import { appLanguage } from '../store/LanguageStore';

export const getLanguages = () => {
    return axios.get<Language[]>(BALANCE_PATH_BASE_URL + '/language/all', {
        headers: {
            'Accept-Language': appLanguage.value?.toLowerCase(),
        },
    });
};

export const authLogin = (loginDTO: LoginDTO) => {
    return axios.post<AuthResponse>(BALANCE_PATH_BASE_URL + '/auth/login', loginDTO);
};

export const forgotPassword = (email: string) => {
    return axios.post(
        BALANCE_PATH_BASE_URL + '/auth/forgot-password',
        { email: email },
        {
            headers: {
                'Content-Type': 'application/json',
            },
        },
    );
};

export const resetPassword = (resetPasswordDTO: ResetPasswordDTO) => {
    return axios.post(BALANCE_PATH_BASE_URL + '/auth/reset-password', resetPasswordDTO, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
};

export const changePassword = (oldPassword: string, newPassword: string) => {
    return axios.put(
        `${BALANCE_PATH_BASE_URL}/auth/changePwd`,
        { oldPassword, newPassword },
        {
            headers: {
                Authorization: `Bearer ${authConfig.value}`,
                'Accept-Language': appLanguage.value?.toLowerCase(),
            },
        },
    );
};

export const refreshToken = () => {
    return axios.put(
        BALANCE_PATH_BASE_URL + '/auth/refresh-token',
        {},
        {
            headers: {
                Authorization: `Bearer ${authConfig.value}`,
                'Accept-Language': appLanguage.value?.toLowerCase(),
            },
        },
    );
};
